import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { $$toast } from '@doger/ui/components/ui/toast';
import type { GoogleAuthRegisterArgs } from '@doger/core/shared/api';
import { $$api } from '@doger/core/shared/api';

type GoogleAuthMutationParams = {
  onSuccess?: (
    data: {
      accessToken: string;
      refreshToken: string;
      isExistingUser: boolean;
    },
    variables: GoogleAuthRegisterArgs
  ) => void;
};

export const useGoogleAuthMutation = (params?: GoogleAuthMutationParams) => {
  const { i18n } = useTranslation();

  return useMutation({
    mutationKey: ['auth', 'signin', 'google'],
    mutationFn: async (args: GoogleAuthRegisterArgs) => {
      const { accessToken, refreshToken, isExistingUser } =
        await $$api.googleAuth({
          ...args,
          language: i18n.language,
        });

      $$api.tokensService.setTokens(accessToken, refreshToken);

      return { accessToken, refreshToken, isExistingUser };
    },

    onSuccess: params?.onSuccess,

    onError: (error) => {
      console.error('Failed to sign in with Google:', error);
      $$toast.error('Failed to sign in with Google. Please try again.');
    },
  });
};
